"use strict";
exports.__esModule = true;
exports.reflect = exports.tezosOperationTag = void 0;
// WILL BE DROPPED =>
exports.tezosOperationTag = {
    OPERATION_TAG_NONE: 0,
    OPERATION_TAG_NONE1: 1,
    OPERATION_TAG_NONE2: 2,
    OPERATION_TAG_GENERIC: 3,
    OPERATION_TAG_NONE4: 4,
    OPERATION_TAG_PROPOSAL: 5,
    OPERATION_TAG_BALLOT: 6,
    OPERATION_TAG_REVEAL: 7,
    OPERATION_TAG_TRANSACTION: 8,
    OPERATION_TAG_ORIGINATION: 9,
    OPERATION_TAG_DELEGATION: 10
};
var reflect = function (declare) {
    declare("TezosLikeAddress", {
        methods: {
            toBase58: {}
        }
    });
    declare("TezosLikeTransaction", {
        methods: {
            getType: {},
            getHash: {},
            getStatus: {},
            getFees: {
                returns: "Amount"
            },
            getValue: {
                returns: "Amount"
            },
            getGasLimit: {
                returns: "Amount"
            },
            getReceiver: {
                returns: "TezosLikeAddress"
            },
            getSender: {
                returns: "TezosLikeAddress"
            },
            serialize: {
                returns: "hex"
            },
            setSignature: {
                params: ["hex"]
            }
        }
    });
    declare("TezosLikeOperation", {
        methods: {
            getTransaction: {
                returns: "TezosLikeTransaction"
            }
        }
    });
    declare("TezosLikeTransactionBuilder", {
        methods: {
            setType: {
                returns: "TezosLikeTransactionBuilder"
            },
            sendToAddress: {
                params: ["Amount"],
                returns: "TezosLikeTransactionBuilder"
            },
            wipeToAddress: {
                returns: "TezosLikeTransactionBuilder"
            },
            setFees: {
                params: ["Amount"],
                returns: "TezosLikeTransactionBuilder"
            },
            setGasLimit: {
                params: ["Amount"],
                returns: "TezosLikeTransactionBuilder"
            },
            setStorageLimit: {
                params: ["BigInt"],
                returns: "TezosLikeTransactionBuilder"
            },
            build: {
                returns: "TezosLikeTransaction"
            }
        }
    });
    declare("TezosLikeAccount", {
        methods: {
            broadcastRawTransaction: {
                params: ["hex"]
            },
            buildTransaction: {
                returns: "TezosLikeTransactionBuilder"
            },
            getStorage: {
                returns: "BigInt"
            },
            getEstimatedGasLimit: {
                returns: "BigInt"
            },
            getFees: {
                returns: "BigInt"
            },
            getOriginatedAccounts: {
                returns: ["TezosLikeOriginatedAccount"]
            }
        }
    });
    declare("TezosLikeOriginatedAccount", {
        methods: {
            getAddress: {},
            getPublicKey: {},
            getBalance: {
                returns: "Amount"
            },
            isSpendable: {},
            isDelegatable: {},
            buildTransaction: {
                returns: "TezosLikeTransactionBuilder"
            },
            queryOperations: {
                returns: "OperationQuery"
            }
        }
    });
    return {
        OperationMethods: {
            asTezosLikeOperation: {
                returns: "TezosLikeOperation"
            }
        },
        AccountMethods: {
            asTezosLikeAccount: {
                returns: "TezosLikeAccount"
            }
        }
    };
};
exports.reflect = reflect;
//# sourceMappingURL=types.js.map